import { render, staticRenderFns } from "./SettingsPerso.vue?vue&type=template&id=55ff223a&scoped=true&"
import script from "./SettingsPerso.vue?vue&type=script&lang=js&"
export * from "./SettingsPerso.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPerso.vue?vue&type=style&index=0&id=55ff223a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff223a",
  null
  
)

export default component.exports